import { ChangeEvent, KeyboardEvent } from 'react'

import MessageInput from 'modules/chat/components/messageInput'
import Icons from 'common/components/icons'
import { MessageWithReply } from 'modules/chat/types'

import './chatFooter.scss'

export interface Props {
  reply?: MessageWithReply,
  removeReplyMessage: () => void,
  addEmoji: (emoji: string) => void,
  sendMessage: () => Promise<void>,
  textInput: string,
  maxRows: number,
  onChangeInput: (event: ChangeEvent<HTMLTextAreaElement>) => void,
  onKeyPress: (event: KeyboardEvent<HTMLTextAreaElement>) => void
}

const ChatFooter = ({
  reply,
  removeReplyMessage,
  addEmoji,
  sendMessage,
  textInput,
  maxRows,
  onChangeInput,
  onKeyPress
}: Props) => {
  return (
    <div className="chat-footer">
      {
        reply
          && (
            <div className="reply-container">
              <div className="messages-header">
                <span className="title">{reply.name}</span>
                <div onClick={removeReplyMessage} className="cursor">
                  <Icons prefix="far" iconName="times"/>
                </div>
              </div>
              <span>{reply.message}</span>
            </div>
          )
      }
      <MessageInput
        addEmoji={addEmoji}
        sendMessage={sendMessage}
        textInput={textInput}
        maxRows={maxRows}
        onChange={onChangeInput}
        onKeyPress={onKeyPress} />
    </div>
  )
}

export default ChatFooter
